import styled from "styled-components";

export const PaymentMethodContainer = styled.div`
    border-bottom: ${props => `1px dashed ${props.theme.colors[props.theme.colorMode].border_Secondary}`};
    padding: ${props => `0 ${props.theme.spacing.medium}`};
    opacity: 0.7;

    &:last-child {
        border-bottom: none;
    }
`;
